import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLogo from "@components/common/AppLogo";
import BackButton from "@components/common/BackButton";
import { selectCtrl, setCtrl } from "@app/global";
import { GridView, toast } from "@ino-ui/tv";
import { getApps, validateAppPin } from "@server/requests";
import LOCAL_STORAGE from "@utils/localStorage";
import Loading from "@components/common/Loading";
import { useTranslation } from "react-i18next";
import { Modal, InoProtectInput } from "@ino-ui/tv";
import { customKeyboard } from "@pages/movieInfo/components/MovieActions";

import "@styles/components/appsPage.scss";
import AppBgSvg from "@assets/icons/AppBgSvg";

export default function AppsPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ctrl = useSelector(selectCtrl);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isAppPinModalOpen, setIsAppPinModalOpen] = useState(false);
  const [appToLaunch, setAppToLaunch] = useState(null);

  const navigate = useNavigate();

  const [apps, setApps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleAppLaunch = async (app) => {
    if (app.is_protected) {
      setAppToLaunch(app);
      setIsAppPinModalOpen(true);
    } else {
      console.log(app);
      const res = window.Android.launchApp(app.app_id);
      if (!res) {
        toast.error("Failed to launch app", { duration: 3000 });
      }
    }
  };

  const handleAppPinSubmit = async (pin) => {
    try {
      const response = await validateAppPin({ app_pin: pin });
      const parsedResponse = JSON.parse(response);

      if (!parsedResponse.error) {
        window.Android?.launchApp(appToLaunch.app_id);
        setIsAppPinModalOpen(false);
        setAppToLaunch(null);
      } else {
        toast.error(parsedResponse.message, { duration: 3000 });
      }
    } catch (err) {
      console.log("", err);
      toast.error("Invalid app pin", { duration: 3000 });
    }
  };

  const getAppsHandler = async () => {
    try {
      setIsLoading(true);
      const res = await getApps({
        device_id: LOCAL_STORAGE.MAC_ADDRESS.GET(),
      });

      const parsedRes = JSON.parse(res);

      if (!parsedRes.error) {
        setApps(parsedRes.message.filter((app) => !app.visible));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAppsHandler();

    if (window.Android) {
      setIsAndroid(true);
    } else {
      dispatch(setCtrl("backBtn"));
    }
  }, []);

  return (
    <div className="apps-page">
      <Modal
        isOpen={isAppPinModalOpen}
        onClose={() => {
          setIsAppPinModalOpen(false);
          setAppToLaunch(null);
        }}
        onCancel={() => {}}
        onOk={() => {}}
        size="full"
      >
        <InoProtectInput
          title="Enter PIN"
          isActive={isAppPinModalOpen}
          count={6}
          isAsterisk={true}
          isOpenKeyboard={true}
          onComplete={handleAppPinSubmit}
          customType={customKeyboard}
          onChange={(value) => {
            console.log(value);
          }}
          clearOnComplete={true}
          onCancel={() => {
            setIsAppPinModalOpen(false);
            setAppToLaunch(null);
          }}
        />
      </Modal>

      {isLoading ? (
        <div className="loading-container">
          <Loading />
        </div>
      ) : (
        <>
          <BackButton
            path="Menu"
            onDownHandler={() => {
              if (!window.Android) return;
              dispatch(setCtrl("apps"));
            }}
            onBackHandler={() => {
              navigate("/menu");
            }}
          />
          <div className="app-logo">
            <AppLogo classNames={"app-logo_top"} />
          </div>
          <div className="apps-content">
            <h2 className="apps-title">{t("Apps Launcher")}</h2>
            {isAndroid ? (
              <div className="grid-view_container">
                <GridView
                  id="apps-grid"
                  uniqueKey="app-"
                  nativeControle={true}
                  rowItemsCount={3}
                  rowCount={Math.ceil(apps.length / 3)}
                  bufferStart={10}
                  bufferEnd={10}
                  itemWidth={35}
                  itemHeight={24.5}
                  isActive={ctrl !== "backBtn" && !isAppPinModalOpen}
                  onOk={(item) => {
                    handleAppLaunch(item);
                  }}
                  initialActiveIndex={0}
                  onChangeRow={() => {}}
                  onUp={() => dispatch(setCtrl("backBtn"))}
                  onDown={() => {}}
                  onBack={() => {
                    navigate("/menu");
                  }}
                  //   onBackScrollIndex={0}
                  renderItem={({ item, index, style, isActive }) => (
                    <div
                      style={style}
                      className={`app-item ${isActive ? "active" : ""}`}
                    >
                      <img
                        src={item.icon || LOCAL_STORAGE.LOGO.GET()}
                        alt={item.name}
                        className="image"
                      />
                      {isActive && <span className="name">{t(item.name)}</span>}
                    </div>
                  )}
                  data={apps}
                />
              </div>
            ) : (
              <p className="android-only">
                {t("This feature is only available on Android devices")}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
}
